<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Certification Information"/>

        <container-list-item padded no-border>
            <b-field label="Title" label-position="inside">
                <b-input v-model="certification.title"></b-input>
            </b-field>
        </container-list-item>

        <template v-if="certification.id">
            <subheader-list-item title="Required Components" icon="fa-cubes"/>

            <card-list-item class="" v-for="o in certification.components">
                <template #icon><i class="fa-fw fas fa-cube"></i></template>
                <template #content>
                    <div class="columns">
                        <div class="column is-10">
                            {{ o.title }}
                        </div>
                        <div class="column has-text-right">
                            <p class="control">
                                <!--                            MOVE BARS ICON?-->
                            </p>
                        </div>
                    </div>
                </template>


                <template #details>
                    <div class="mt-3">
                        <toolbar class="toolbar">
                            <button class="icon-only" @click.stop="deleteComponent(o)"><i class="far fa-trash"></i></button>
                        </toolbar>
                    </div>
                </template>
            </card-list-item>


            <card-list-item class="pb-5" no-hover>
                <template #icon><i class="fa-fw fas fa-plus"></i></template>
                <template #content>
                    <div class="columns">
                        <div class="column is-10">
                            <div class="mb-2">
                                <b-select expanded placeholder="Component" v-model="componentSelect" @input="title = componentSelect.title">
                                    <option :value="c" v-for="c in components">{{ c.title }}</option>
                                </b-select>
                            </div>
                        </div>
                        <div class="column has-text-right">
                            <p class="control">
                                <button class="button is-primary" :disabled="!componentSelect" @click="addComponent"><i class="far fa-fw fa-plus"></i></button>
                            </p>
                        </div>
                    </div>
                </template>
            </card-list-item>
        </template>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";
    import {client as http} from "@/http_client";
    import Toolbar from "@/TIER/components/Toolbar";


    export default {
        name: 'CertificationForm',
        props: {
            certification: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList, Toolbar},
        data: function() {
            return {
                componentSelect: null,
                components: []
            };
        },
        computed: {},
        methods: {
            loadComponents(force) {
                this.$emit('loading', true);

                http.get('components/', {force}).then(response => {
                    this.components = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            addComponent() {
                http.post('certs/assign', {
                    cert_id: this.certification.id,
                    component_id: this.componentSelect.id
                }, {force: true}).then(response => {
                    this.componentSelect = null;
                    this.certification.components.push(response.data);
                }, err => {
                    console.log(err);
                });
            },
            deleteComponent(comp) {
                http.delete('certs/assign/' + comp.id, {force: true}).then(response => {
                    this.certification.components.splice(this.certification.components.indexOf(comp), 1);
                }, err => {
                    console.log(err);
                });
            }
        },
        mounted: function() {
            this.loadComponents();
        }
    };
</script>
